import { Flags, ValueOfKey } from '../../utils-types';

export const CHALLENGE_SECTION = {
  ABOUT: 'ABOUT',
  IMPORTANT_DATES: 'IMPORTANT_DATES',
  PRIZES: 'PRIZES',
  FAQ: 'FAQ',
} as const;

export type ChallengeSectionKey = ValueOfKey<typeof CHALLENGE_SECTION>;
export type ChallengeSectionFlags = Flags<ChallengeSectionKey>;
